/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, March 31st 2022, 1:18:39 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { BillingConfigurationMany2OnePicker } from "service-builder/components/billing";
import { TaskTemplate } from "lib/schemas";

export const BillingTaskSettings = () => {
  return (
    <BillingConfigurationMany2OnePicker<TaskTemplate>
      schema_field_key="billing_configuration"
      label="Billing Configuration"
    />
  );
};
